<template>
<div>
  <v-card>
    <v-card-title>
     کنترل پیشنهادات
      <v-spacer/>
      <v-btn color="error" @click="closeForm">بستن</v-btn>

    </v-card-title>
      <v-divider></v-divider>
      <v-card-text >
        <TradeRequestManageResponse></TradeRequestManageResponse>
      </v-card-text>
     
  </v-card>
</div>
</template>
<script>
import TradeRequestManageResponse from '../components/TradeRequestManageResponse.vue';
export default {
  data() {
    return {};
  },
  components: {
    TradeRequestManageResponse,
  },
  methods: {
    closeForm(){
      this.clearStore()
      this.$router.push({ path: `/trade-request`})
    },
    clearStore(){
      this.$store.commit('setTradeRequestFormStatus',false )
      this.$store.commit('setTradeRequestIsEdit',false )
      this.$store.commit('setTradeRequestSelectedForEdit',null )
      this.$store.commit('setTradeRequestShowDetailForm',false )
      this.$store.commit('setTradeRequestSingleItem',null )
      this.$store.commit('setTradeRequestSingleItemForEdit',null )
      this.$store.commit('setTradeRequestItems',[] )
      this.$store.commit('setTradeRequestSelectedForDisplay',null )
      this.$store.commit('setTradeRequestCategoryType',null )
      this.$store.commit('setTradeRequestEditMode',false )
      this.$store.commit('setTradeRequestResponsesPerItem',null )
      this.$store.commit('setTradeRequestNumber',null )
      this.$store.commit('setTradeRequestDate',null )
      this.$store.commit('setTradeRequestResponsesHeader',null )
      this.$store.commit('setTradeRequestSelectedForResponse',null )

  }
  },
};
</script>

<style></style>